var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6299_100961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.99935C9.5 10.2204 9.5878 10.4323 9.74408 10.5886C9.90036 10.7449 10.1123 10.8327 10.3333 10.8327C10.5543 10.8327 10.7663 10.7449 10.9226 10.5886C11.0789 10.4323 11.1667 10.2204 11.1667 9.99935C11.1667 9.77834 11.0789 9.56637 10.9226 9.41009C10.7663 9.25381 10.5543 9.16602 10.3333 9.16602C10.1123 9.16602 9.90036 9.25381 9.74408 9.41009C9.5878 9.56637 9.5 9.77834 9.5 9.99935Z",
    stroke: "#7D778C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.8333C9.5 16.0543 9.5878 16.2663 9.74408 16.4226C9.90036 16.5789 10.1123 16.6667 10.3333 16.6667C10.5543 16.6667 10.7663 16.5789 10.9226 16.4226C11.0789 16.2663 11.1667 16.0543 11.1667 15.8333C11.1667 15.6123 11.0789 15.4004 10.9226 15.2441C10.7663 15.0878 10.5543 15 10.3333 15C10.1123 15 9.90036 15.0878 9.74408 15.2441C9.5878 15.4004 9.5 15.6123 9.5 15.8333Z",
    stroke: "#7D778C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.16732C9.5 4.38833 9.5878 4.60029 9.74408 4.75657C9.90036 4.91285 10.1123 5.00065 10.3333 5.00065C10.5543 5.00065 10.7663 4.91285 10.9226 4.75657C11.0789 4.60029 11.1667 4.38833 11.1667 4.16732C11.1667 3.9463 11.0789 3.73434 10.9226 3.57806C10.7663 3.42178 10.5543 3.33398 10.3333 3.33398C10.1123 3.33398 9.90036 3.42178 9.74408 3.57806C9.5878 3.73434 9.5 3.9463 9.5 4.16732Z",
    stroke: "#7D778C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6299_100961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/kebab.b23949c8e1d2143b6c4712562f8713f0.svg";
export { ForwardRef as ReactComponent };